import React from 'react';
import styled from 'styled-components';

type SpecialDetailHeaderProps = {
  displayDescription?: string;
  showExpiredSpecial?: boolean;
};

export function SpecialDetailHeader({
  displayDescription,
  showExpiredSpecial = false,
}: SpecialDetailHeaderProps): JSX.Element {
  return (
    <Container $showExpiredSpecial={showExpiredSpecial} data-testid='special-detail-header'>
      {displayDescription && (
        <TextContainer>
          <Description>{displayDescription}</Description>
        </TextContainer>
      )}
    </Container>
  );
}

const Container = styled.div<{ $showExpiredSpecial: boolean }>`
  width: 100%;
  ${({ $showExpiredSpecial }) =>
    $showExpiredSpecial &&
    `
    filter: grayscale(80%) opacity(0.75);
  `}
  margin-bottom: 8px;
`;

const TextContainer = styled.div`
  margin: 16px 0;
`;

const Description = styled.p`
  font-size: 16px;
  line-height: 1.4;
  color: var(--dcm-color-text-secondary, #485055);
  word-break: break-word;
`;
